// removed by extract-text-webpack-plugin
module.exports = {"component":"GO8VRW6IM3UVXkbyXf-a7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/cart.css
// module id = 1261
// module chunks = 2